<template>
  <div class="evento-container">
    <img src="@/assets/esq-.png" alt="Decoración Superior Izquierda" class="decoracion-sup-izq" />

    <div class="evento-card" ref="card1">
      <img src="@/assets/10.png" alt="Ceremonia Religiosa" class="evento-icono1" />
      <p class="evento-titulo">Ceremonia Religiosa</p>
      <p class="evento-fecha">Miercoles 30 de Diciembre</p>
      <p class="evento-lugar"> Nuestra Señora de Guadalupe </p>
      <p class="evento-direccion"> Poblado Nueva Apolonia   <br>Cd. Mante, Tamaulipas.</p>

      <p class="evento-hora">1:00 P.M.</p>
      <a href="https://maps.app.goo.gl/BkdXiDUejqmJEPMw7" class="btn-mapa" target="_blank">VER MAPA</a>
    </div>

    <div class="linea-division" ref="lineaCentral"></div>

    <div class="evento-card" ref="card2">
      <img src="@/assets/8.png" alt="Ceremonia Civil" class="evento-icono" />
      <p class="evento-titulo">Celebración</p>
      <p class="evento-fecha">Miercoles 30 de Diciembre</p>
      <p class="evento-lugar">Casa de los Festejados </p>
      <p class="evento-direccion">Calle Quinta S/N Nueva Apolonia <br>Cd. Mante, Tamaulipas.</p>
      <p class="evento-hora">3:00 P.M.</p>
      <a href="https://maps.app.goo.gl/T9hPieeJp8hRXYXa8" class="btn-mapa" target="_blank">VER MAPA</a>
    </div>

    <img src="@/assets/esqq.png" alt="Decoración Derecha" class="decoracion-der" />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'EventoSection',
  setup() {
    const card1 = ref(null)
    const card2 = ref(null)
    const lineaCentral = ref(null)

    onMounted(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (entry.target === card1.value) {
                gsap.fromTo(card1.value, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 1.2 })
              }
              if (entry.target === lineaCentral.value) {
                gsap.fromTo(lineaCentral.value, { scaleY: 0 }, { scaleY: 1, transformOrigin: 'top', duration: 0.8 })
              }
              if (entry.target === card2.value) {
                gsap.fromTo(card2.value, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 1.2, delay: 0.3 })
              }
              observer.unobserve(entry.target)
            }
          })
        },
        { threshold: 0.4 }
      )

      observer.observe(card1.value)
      observer.observe(lineaCentral.value)
      observer.observe(card2.value)
    })

    return { card1, card2, lineaCentral }
  }
}
</script>

<style scoped>
.evento-container {
  background-image: url('@/assets/7.png');
  background-size: cover;
  background-position: center;
  padding: 60px 20px 120px; /* Incrementado el padding inferior para dar espacio a los elementos decorativos */
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #121111;
  position: relative; /* Clave para posicionar las esquinas de forma absoluta */
  overflow: hidden;
}

.evento-card {
  text-align: center;
  margin-bottom: 50px;
  max-width: 300px;
  opacity: 0;
  z-index: 2; /* Asegura que el texto quede por encima de los fondos decorativos */
}

.evento-icono {
  width: 78px;
  margin-bottom: 12px;
}

.evento-icono1 {
  width: 98px;
  margin-bottom: 12px;
}

.evento-titulo {
  font-family: 'Corinthia', cursive;
  font-size: 44px !important;
  color: #121111;
  margin: 0 0 6px;
}

.evento-fecha {
  font-family: 'padres', serif;
  font-size: 14px;
  color: #121111;
  margin-bottom: 6px;
}

.evento-lugar {
  font-family: 'padres', serif;
  font-size: 15px;
  font-weight: bold;
  color: #121111;
  margin-bottom: 6px;
}

.evento-direccion {
  font-family: 'padres', serif;
  font-size: 12px;
  color: #121111;
  margin-bottom: 6px;
}

.evento-hora {
  font-family: 'fa', sans-serif;
  font-size: 18px;
  color: #121111;
  font-style: italic;
  margin-bottom: 12px;
}

.btn-mapa {
  background: transparent;
  border: 1px solid #292929;
  color: #1c1b1b;
  font-size: 13px;
  padding: 6px 18px;
  text-decoration: none;
  font-family: 'padres', serif;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  display: inline-block;
}

.btn-mapa:hover {
  background: #0b2347; /* Sutil toque azul rey al interactuar */
  color: #fff;
  border-color: #0b2347;
}

.linea-division {
  width: 2px;
  height: 40px;
  background: #0b2347; /* Cambiado a un elegante Azul Rey acorde a tu temática */
  margin: 20px 0;
  transform: scaleY(0);
  z-index: 2;
}

/* ESTILOS DE LAS IMÁGENES DE LAS ESQUINAS */
.decoracion-sup-izq {
  position: absolute;
  top: 0;
  left: 0;
  width: min(100px, 20vw);
  height: auto;
  pointer-events: none;
  z-index: 10;
  display: block;
  opacity: 1 !important; /* Salta la animación de GSAP */
}

.decoracion-izq {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 20px !important; /* Ajuste responsivo base */
  height: auto;
  z-index: 1;
  pointer-events: none; /* Evita interferencias con los clics del usuario */
}

.decoracion-der {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 180px !important; /* Ajuste responsivo base */
  height: auto;
  z-index: 1;
  pointer-events: none;
}

@media (max-width: 420px) {
 
}
</style>